import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

const root = document.getElementById('root');
if (root) {
  const appContent = (
    <ErrorBoundary>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ErrorBoundary>
  );

  // Only hydrate in production when the shell was pre-rendered (non-empty #root).
  // In development, always render: stray whitespace/nodes in #root would break hydrateRoot.
  const shouldHydrate =
    process.env.NODE_ENV === 'production' && root.hasChildNodes();

  if (shouldHydrate) {
    hydrateRoot(root, appContent);
  } else {
    createRoot(root).render(appContent);
  }
}
